import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrokerService } from '../broker.service';
import { BrokerData } from '../broker.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-broker-app-bar-title',
    templateUrl: './broker-app-bar-title.component.html',
    styleUrls: ['./broker-app-bar-title.component.scss'],
    standalone: false
})
export class BrokerAppBarTitleComponent implements OnInit {

  title: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private brokerService: BrokerService) { }

  back() {
    this.router.navigateByUrl(this.brokerService.prevBrokerListUrl || '/broker');
  }

  data: BrokerComponentData;

  dataSet(data: BrokerComponentData) {
    this.data = data;
    this.title = data.broker && data.broker.name ? data.broker.name : '';
  }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe(this.dataSet.bind(this));
  }
}

export interface BrokerComponentData {
  broker: BrokerData;
}
